export const getShowDiscountedCopy = ({
  pricingInfo
}) => {
  const {
    monthly: {
      fullPrice: monthlyFullPrice,
      calculatedPrice: monthlyCalculatedPrice
    },
    offerInfo
  } = pricingInfo;
  const discount = offerInfo && 'discount' in offerInfo ? offerInfo.discount : 0;
  const hasDiscount = discount > 0 || monthlyFullPrice > monthlyCalculatedPrice;
  return hasDiscount;
};